// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__MswPk","formTitle":"ForgotPassword_formTitle__GA8mz","formBtn":"ForgotPassword_formBtn__-+k3P"};